var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page',[_c('base-container',{class:["picker-page"]},[_c('cube-basic-picker'),_c('div',{class:["picker-divider-wrapper"]},[_c('cube-divider')],1),_c('cube-multi-picker'),_c('div',{class:["picker-divider-wrapper"]},[_c('cube-divider')],1),_c('cube-api-picker')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }